import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useEffect } from 'react';
import { useChatbotMgr } from '../ai/ChatbotMgrContext';
import { SideNavButton } from './SideNavButton';

export const HelpButton = () => {
  const { toggleOpen } = useChatbotMgr();

  // Global F1 shortcut toggles the in-app AI chat panel.
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key !== 'F1') return;

      event.preventDefault();
      toggleOpen();
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [toggleOpen]);

  return <SideNavButton onClick={toggleOpen} tooltip="Ask Kernel" icon={fas.faCircleQuestion} />;
};
